import { useMemo } from 'react';
import { CollapsibleSection } from '@/components/shared/CollapsibleSection';
import { InfoPanel } from '@/components/shared/InfoPanel';
import { LoadingState } from '@reflex/ui/components/shared/LoadingState';
import { LogViewer } from '@reflex/ui/components/content/log-viewer';
import { formatBlueprintBuildLog } from '@reflex/shared';
import type { BlueprintLogEntry } from '@/lib/types';

interface BuildLogsSectionProps {
  logs: BlueprintLogEntry[] | undefined;
  isLoading: boolean;
  blueprintId: string;
  defaultOpen?: boolean;
}

export function BuildLogsSection({
  logs,
  isLoading,
  blueprintId,
  defaultOpen = true,
}: BuildLogsSectionProps) {
  const content = useMemo(() => (logs ? formatBlueprintBuildLog(logs) : ''), [logs]);

  return (
    <CollapsibleSection title="Build Logs" defaultOpen={defaultOpen}>
      {isLoading ? (
        <InfoPanel className="overflow-hidden p-0">
          <LoadingState />
        </InfoPanel>
      ) : logs && logs.length > 0 ? (
        <div className="h-[60vh]">
          <LogViewer content={content} path={`blueprint-${blueprintId}-build.log`} />
        </div>
      ) : (
        <InfoPanel className="overflow-hidden p-0">
          <p className="p-4 text-center text-xs text-muted-foreground">No logs available</p>
        </InfoPanel>
      )}
    </CollapsibleSection>
  );
}
